import AuditLog from '@/pages/AuditLog';
import SystemMaintenance from '@/pages/system/SystemMaintenance';
import MaintenanceIndex from '@/pages/system/MaintenanceIndex';
// import Menus from '@/pages/system/Menus';
// import UserMenus from '@/pages/system/UserMenus';

export default [
  {
    path: '/audit-log',
    name: 'audit-log',
    component: AuditLog,
    meta: {
      requiresAuth: true,
      permissions: ['perm_view_audit_logs'],
    },
  },
  {
    path: '/maintenance',
    component: SystemMaintenance,
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        path: '',
        name: 'maintenance',
        redirect: { name: 'maintenance.index' },
      },
      {
        path: '',
        name: 'maintenance.index',
        component: MaintenanceIndex,
        meta: {
          permissions: ['perm_system_maintenance'],
        },
      },
      // { TODO: not yet available feature
      //   path: 'menus',
      //   name: 'maintenance.menus',
      //   component: Menus,
      //   meta: {
      //     permissions: ['perm_manage_menus'],
      //   },
      // },
      // {
      //   path: 'user-menus',
      //   name: 'maintenance.user_menus',
      //   component: UserMenus,
      //   meta: {
      //     permissions: ['perm_manage_menus'],
      //   },
      // },
    ],
  },
];
